import { render, staticRenderFns } from "./TimeLimitDisplay.vue?vue&type=template&id=55631dd9&scoped=true&"
import script from "./TimeLimitDisplay.vue?vue&type=script&lang=js&"
export * from "./TimeLimitDisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55631dd9",
  null
  
)

export default component.exports